import axios from "axios";
import { baseURL } from "config";
import { convertKeysToCamelCase } from "utils/caseConvertor";

async function getSurveyDetailsByToken(token: string) {
  const res = await axios.get(`${baseURL}/survey-and-polls/${token}`);
  const data = convertKeysToCamelCase(res.data);

  return data;
}

export default getSurveyDetailsByToken;
